import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dbbf439"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "customize-rates-modal",
  "data-toggle": "modal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "customize-rates-modal-label"
  }, "Customize rate"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1))
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Level"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Rate"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Night bonus"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-end" }, "Weekend bonus")
  ])
], -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "fs-5 fw-bold" }
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = { class: "text-end d-flex justify-content-end" }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = { class: "modal-footer" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Close ", -1))
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _hoisted_8,
              (_ctx.hasModelData)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedLevels, (level) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: level.id
                      }, [
                        _createElementVNode("td", _hoisted_10, _toDisplayString(level.name), 1),
                        _createElementVNode("td", _hoisted_11, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control w-100 h-32px",
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.model[level.id].base_rate) = $event)
                          }, null, 8, _hoisted_12), [
                            [_vModelText, _ctx.model[level.id].base_rate]
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control w-100 h-32px",
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.model[level.id].night_bonus) = $event)
                          }, null, 8, _hoisted_13), [
                            [_vModelText, _ctx.model[level.id].night_bonus]
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_14, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control w-100 h-32px",
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.model[level.id].weekend_bonus) = $event)
                          }, null, 8, _hoisted_15), [
                            [_vModelText, _ctx.model[level.id].weekend_bonus]
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSaveLevelRates && _ctx.handleSaveLevelRates(...args))),
            disabled: _ctx.isSaving
          }, [
            (_ctx.isSaving)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19))
              : _createCommentVNode("", true),
            _hoisted_20
          ], 8, _hoisted_18)
        ])
      ])
    ])
  ]))
}